<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">

          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'reports.filter.shop' | transloco }}</small>
              <hx-store-select
                [(ngModel)]="params.storeIds"
                [multiple]="true"
                (selectChange)="onStoreChanged($event)">
              </hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.date' | transloco }}</small>
              <hx-date-range-select
                [(ngModel)]="params.date"
                (selectChange)="navigate()">
              </hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.status' | transloco }}</small>
              <ng-select bindLabel="label" bindValue="id" [multiple]="true" [placeholder]="'ord.order-list.status' | transloco"
                         [(ngModel)]="params.actions" (change)="navigate()">
                <ng-option *ngFor="let op of typeOptions" [value]="op.id">{{op.label | transloco}}</ng-option>
              </ng-select>
            </div>

            <div class="filter">
              <div class="filter">
                <small>{{ 'managers' | transloco }}</small>

                <ng-select
                  multiple="true"
                  [(ngModel)]="params.managerUserIds"
                  (change)="navigate()"
                  [placeholder]="'managers' | transloco"
                  bindValue="id"
                  bindLabel="fullname"
                  [closeOnSelect]="false">
                  <ng-option *ngFor="let op of managers" [value]="op.id">
                    {{ op.fullname }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>

          <div class="m--margin-top-15">
            @if (params.storeIds.length) {
              <button type="button" (click)="generate()" class="btn btn-outline-success m--margin-right-10"
                      [disabled]="isLoading.generate" [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.generate}">
                {{ 'download' | transloco }}
              </button>
            }

            <button
              type="button"
              (click)="resetFilter()"
              class="btn btn-outline-primary">
              {{ 'reset.list' | transloco }}
            </button>
          </div>

          <div *ngIf="list.length && !isLoading.list" class="block-table-scroll m--margin-top-30">
            <div>
              <span><span class="font-weight-bold">{{ 'manager-sales.totalOrder' | transloco }}:</span> {{ totalSum | number }}</span>
              <span class="m--margin-left-10"><span class="font-weight-bold">{{ 'manager-sales.totalOrderCount' | transloco }}:</span> {{ list.length | number }}</span>
            </div>

            <table class="m--margin-top-10 m--margin-bottom-40 table-report">
              <thead>
              <tr>
                <th class="text-align-center">№</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.uniqueNumber' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.manager' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.orderCreated' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.orderDate' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.decorText' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.status' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.paymentType' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.total' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.paid' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.totalDiscount' | transloco }}</th>
                <th class="text-align-center">{{ 'manager-sales.table.head.client' | transloco }}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let even = even;let i = index; let r of list">
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>
                    <a [routerLink]="['../../orders/' + r.orderId]">
                      {{ r.uniqueNumber }}
                    </a>
                  </td>
                  <td>{{ r.actorFullname }}</td>
                  <td>{{ r.orderCreateDate | date:'dd.MM.YYYY HH:ss' }}</td>
                  <td>{{ r.orderDate | date:'dd.MM.YYYY HH:ss' }}</td>
                  <td>{{ r.decorText }}</td>
                  <td>{{ 'action.' + r.status | transloco }}</td>
                  <td>
                    <span *ngFor="let t of r.paymentTypes; let last = last">
                        {{ ('paymentType.' + t) | transloco }}<span *ngIf="!last">, </span>
                    </span>
                  </td>
                  <td>{{ r.total ?? 0 | number }}</td>
                  <td>{{ (r.paymentDate ? 'manager-sales.table.paid' : 'manager-sales.table.notpaid') | transloco }}</td>
                  <td>{{ r.totalDicount ?? 0 | number }}</td>
                  <td>{{ r.clientFullname }} {{ r.clientPhone }}</td>
                </tr>
              </ng-container>
              </tbody>
              <tfoot>
                <td colspan="5" class="font-weight-bold">{{ 'manager-sales.table.footer.total' | transloco }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td class="font-weight-bold">{{ totalSum | number }}</td>
                <td></td>
                <td class="font-weight-bold">{{ totalDiscountSum | number }}</td>
                <td></td>
              </tfoot>
            </table>
          </div>
          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

        </div>
      </div>
    </div>
  </div>
</div>
